import { render, staticRenderFns } from "./BroadcastAdmin.vue?vue&type=template&id=1ffc311b&"
import script from "./BroadcastAdmin.vue?vue&type=script&lang=js&"
export * from "./BroadcastAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports